require('./collapsingTogglePromoCode.scss');

const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

class CollapsingTogglePromoCode extends React.Component {
    render() {
        const { isExpanded, iconStyle, onClick } = this.props;
        const iconClassName = classNames('collapsing-toggle__toggle icons', {
            'icons--icon-arrow-up': isExpanded,
            'icons--icon-arrow-down': !isExpanded,
            [iconStyle]: !!iconStyle,
        });

        return (
            <div className="collapsing-toggle-promo-code">
                <i className={iconClassName} onClick={onClick} />
            </div>
        );
    }
}

CollapsingTogglePromoCode.propTypes = {
    isExpanded: PropTypes.bool.isRequired,
    iconStyle: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};

CollapsingTogglePromoCode.defaultProps = {
    isExpanded: false,
    iconStyle: '',
};

module.exports = CollapsingTogglePromoCode;
